

// (function () {
//     // Product pages where header should be hidden
//     const hideHeaderPaths = [
//         "/products/dad-bod-belly-buster-stack-v2"
//     ];

//     // Exit if not on target product pages
//     if (!hideHeaderPaths.includes(window.location.pathname)) return;

//     // Detect Australian region (Shopify localization)
//     function isAustralia() {
//         if (window.Shopify && Shopify.country) {
//             return Shopify.country === "AU";
//         }

//         // Fallback if Shopify object loads late
//         if (window.Shopify && Shopify.locale) {
//             return Shopify.locale.toLowerCase().includes("au");
//         }

//         return false;
//     }

//     function hideHeader() {
//         if (!isAustralia()) return;

//         const header = document.querySelector("#shopify-section-header1");
//         if (!header) return;

//         header.classList.add("hideheader");
//         header.style.display = "none";

//         console.log("✅ Header hidden (AU region + allowed product page)");
//     }

//     // Run immediately
//     hideHeader();

//     // Run again after DOM load (Impulse theme loads some sections late)
//     document.addEventListener("DOMContentLoaded", hideHeader);
// })();


// document.addEventListener("DOMContentLoaded", function () {

//   const radios = document.querySelectorAll('input[name="purchase_type"]');

//   const subscribeForm = document.querySelector('input[value="subscribe"]')
//     .closest(".buy-option")
//     .querySelector("form");

//   const oneTimeForm = document.querySelector(
//     '.custom-buy-box form[action="/cart/add"]:not(.buy-option form)'
//   );

//   const freebiesWrapper = document.querySelector('.freebies-wrapper');

//   const bonusBanner = document.querySelector('.bonus-unlocked-banner');

//   function updateUI(selected) {

//     /* ========================= */
//     /* FORM SWITCHING */
//     /* ========================= */

//     if (selected === "subscribe") {

//       subscribeForm.style.display = "block";
//       oneTimeForm.style.display = "none";

//     } else {

//       subscribeForm.style.display = "none";
//       oneTimeForm.style.display = "block";

//     }

//     /* ========================= */
//     /* LOCK / UNLOCK FREEBIES */
//     /* ========================= */

//     if (selected === "one_time") {

//       freebiesWrapper.classList.add("locked");
//       bonusBanner.classList.add("locked");

//       console.log("LOCKED");

//     } else {

//       freebiesWrapper.classList.remove("locked");
//       bonusBanner.classList.remove("locked");

//       console.log("UNLOCKED");

//     }

//   }

//   /* ========================= */
//   /* RADIO CHANGE */
//   /* ========================= */

//   radios.forEach(radio => {

//     radio.addEventListener("change", function () {

//       updateUI(this.value);

//     });

//   });

//   /* ========================= */
//   /* INITIAL STATE */
//   /* ========================= */

//   const checked = document.querySelector(
//     'input[name="purchase_type"]:checked'
//   );

//   if (checked) {
//     updateUI(checked.value);
//   }

// });

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// sales strip insert image

// (function () {
//   const excludedPages = [
//     "/products/pure-stallion-v2",
//     "/products/pure-stallion-protocol"
//   ];

//   if (excludedPages.includes(window.location.pathname)) return;

//   function insertBanner() {
//     const target = document.querySelector(".ecom-product-single__add-to-cart-buttons-wrapper");

//     if (!target || document.querySelector(".custom-product-banner")) return;

//     const wrapper = document.createElement("div");
//     wrapper.className = "custom-product-banner";

//     Object.assign(wrapper.style, {
//       width: "100%",
//       marginTop: "16px"
//     });

//     const img = document.createElement("img");
//     img.src = "https://cdn.shopify.com/s/files/1/0867/9673/0684/files/BFCM_Strips_PP.webp?v=1793208473";
//     img.alt = "Promotion";
//     img.loading = "lazy";

//     Object.assign(img.style, {
//       display: "block",
//       width: "100%",
//       maxWidth: "100%",
//       height: "auto",
//       borderRadius: "8px",
//       cursor: "pointer"
//     });

//     wrapper.appendChild(img);

//     // Insert directly below the add-to-cart buttons wrapper
//     target.insertAdjacentElement("afterend", wrapper);
//   }

//   insertBanner();

//   const observer = new MutationObserver(insertBanner);
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// })();


// //////////////////////////////////////////////////////////////////////////////////Sticky///////////////////

(() => {
    // Only run on Pure Stallion Protocol
    if (window.location.pathname !== '/products/pure-stallion-protocol') {
        return;
    }

    // Desktop only
    if (window.innerWidth < 1025) {
        return;
    }

    function fixProductGallerySticky() {
        // Don't do anything if switched to mobile/tablet
        if (window.innerWidth < 1025) return;

        const gallery = document.querySelector(
            '.ecom-product-single__media'
        );

        if (!gallery) return;

        const parent = gallery.parentElement;
        const section = gallery.closest('.ecom-section');

        if (!parent || !section) return;

        // Make the parent as tall as the product section
        parent.style.setProperty(
            'height',
            `${section.offsetHeight}px`,
            'important'
        );

        // Manually enable sticky
        gallery.classList.remove('ecom-position-sticky');

        gallery.style.setProperty(
            'position',
            'sticky',
            'important'
        );

        gallery.style.setProperty(
            'top',
            '100px',
            'important'
        );

        gallery.style.setProperty(
            'align-self',
            'flex-start',
            'important'
        );
    }

    fixProductGallerySticky();

    // EComposer may finish rendering after page load
    setTimeout(fixProductGallerySticky, 500);
    setTimeout(fixProductGallerySticky, 1500);
    setTimeout(fixProductGallerySticky, 3000);

    // Recalculate when desktop window is resized
    window.addEventListener('resize', () => {
        if (window.innerWidth >= 1025) {
            fixProductGallerySticky();
        }
    });
})();


//////////////////////////////////////////////////////////////////////////////////////////homepagehomepagehomepagehomepagehomepagehomepagehomepagehomepage
/////////////////////////////////////////////////////////////////////////////////////////homepagehomepagehomepagehomepagehomepagehomepagehomepagehomepage


document.addEventListener('DOMContentLoaded', function () {

  // ==========================================
  // HOMEPAGE ONLY
  // ==========================================

  if (window.location.pathname !== '/') {
    return;
  }


  // ==========================================
  // INGREDIENTS SECTION
  // ==========================================

  const section = document.querySelector(
    '#ecom-688c1c66e6c4960ea00288e7'
  );

  if (!section) {
    return;
  }


  // ==========================================
  // GET BUTTONS
  // ==========================================

  function getButtons() {

    return [
      section.querySelector('.ingredientsBtn.btn1 a'),
      section.querySelector('.ingredientsBtn.btn2 a'),
      section.querySelector('.ingredientsBtn.btn3 a'),
      section.querySelector('.ingredientsBtn.btn4 a'),
      section.querySelector('.ingredientsBtn.btn5 a')
    ];

  }


  // ==========================================
  // GET CONTAINERS
  // ==========================================

  function getContainers() {

    return [
      section.querySelector('.button1Container'),
      section.querySelector('.button2Container'),
      section.querySelector('.button3Container'),
      section.querySelector('.button4Container'),
      section.querySelector('.button5Container')
    ];

  }


  // ==========================================
  // ACTIVATE CONTAINER
  // ==========================================

  function activate(index) {

    const buttons = getButtons();
    const containers = getContainers();


    // Make sure everything exists
    if (
      buttons.some(function (button) {
        return !button;
      }) ||
      containers.some(function (container) {
        return !container;
      })
    ) {
      return;
    }


    // ========================================
    // HIDE ALL CONTAINERS
    // ========================================

    containers.forEach(function (container) {

      container.classList.remove(
        'container-active'
      );

      container.style.setProperty(
        'display',
        'none',
        'important'
      );

      container.style.setProperty(
        'opacity',
        '0',
        'important'
      );

    });


    // ========================================
    // RESET ALL BUTTONS
    // ========================================

    buttons.forEach(function (button) {

      button.classList.remove(
        'btnActiveWhiteBtn'
      );

    });


    // ========================================
    // SHOW SELECTED CONTAINER
    // ========================================

    const activeContainer = containers[index];
    const activeButton = buttons[index];


    if (!activeContainer || !activeButton) {
      return;
    }


    activeButton.classList.add(
      'btnActiveWhiteBtn'
    );


    activeContainer.classList.add(
      'container-active'
    );


    activeContainer.style.setProperty(
      'display',
      'flex',
      'important'
    );


    activeContainer.style.setProperty(
      'opacity',
      '1',
      'important'
    );

  }


  // ==========================================
  // WAIT FOR ECOMPOSER
  // ==========================================

  function initialize() {

    const buttons = getButtons();
    const containers = getContainers();


    if (
      buttons.some(function (button) {
        return !button;
      }) ||
      containers.some(function (container) {
        return !container;
      })
    ) {
      return false;
    }


    // ========================================
    // ADD CLICK EVENTS
    // ========================================

    buttons.forEach(function (button, index) {

      if (
        button.dataset.ingredientsInitialized === 'true'
      ) {
        return;
      }


      button.dataset.ingredientsInitialized = 'true';


      button.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          activate(index);

        }
      );

    });


    // ========================================
    // DEFAULT = BUTTON 5
    // ========================================

    if (
      document.body.dataset.ingredientsInitialized !== 'true'
    ) {

      activate(4);

      document.body.dataset.ingredientsInitialized = 'true';

    }


    return true;

  }


  // ==========================================
  // INITIALIZE
  // ==========================================

  initialize();


  // ==========================================
  // ECOMPOSER RETRY
  // ==========================================

  let attempts = 0;

  const retry = setInterval(function () {

    attempts++;

    initialize();


    if (attempts >= 10) {
      clearInterval(retry);
    }

  }, 500);

});


// //////////////////////////////////////slider homepage///////////////////////


(function () {

  function initTestimonials() {

    const root = document.querySelector("#jacobTestimonials");

    if (!root || root.dataset.initialized === "true") {
      return;
    }

    const slider = root.querySelector(".jt-slider");
    const cards = root.querySelectorAll(".jt-card");
    const dotsContainer = root.querySelector(".jt-dots");
    const prev = root.querySelector(".jt-prev");
    const next = root.querySelector(".jt-next");

    if (
      !slider ||
      !cards.length ||
      !dotsContainer ||
      !prev ||
      !next
    ) {
      return;
    }

    root.dataset.initialized = "true";

    let currentIndex = 0;
    let autoplay = null;


    /* ================================
       CARDS PER VIEW
    ================================= */

    function getCardsPerView() {

      if (window.innerWidth <= 650) {
        return 1;
      }

      if (window.innerWidth <= 1100) {
        return 2;
      }

      return 4;

    }


    /* ================================
       MAX INDEX
    ================================= */

    function getMaxIndex() {

      return Math.max(
        0,
        cards.length - getCardsPerView()
      );

    }


    /* ================================
       CREATE DOTS
    ================================= */

    function createDots() {

      dotsContainer.innerHTML = "";

      const maxIndex = getMaxIndex();

      for (
        let i = 0;
        i <= maxIndex;
        i++
      ) {

        const dot = document.createElement("button");

        dot.type = "button";
        dot.className = "jt-dot";

        dot.setAttribute(
          "aria-label",
          "Go to testimonial " + (i + 1)
        );

        if (i === currentIndex) {
          dot.classList.add("active");
        }

        dot.addEventListener(
          "click",
          function () {

            currentIndex = i;

            updateSlider();

            restartAutoplay();

          }
        );

        dotsContainer.appendChild(dot);

      }

    }


    /* ================================
       UPDATE SLIDER
    ================================= */

    function updateSlider() {

      const card = cards[0];

      if (!card) {
        return;
      }

      const cardWidth =
        card.getBoundingClientRect().width;

      const gap =
        parseFloat(
          window.getComputedStyle(slider).gap
        ) || 0;

      const offset =
        currentIndex *
        (cardWidth + gap);

      slider.style.transform =
        "translate3d(-" +
        offset +
        "px, 0, 0)";


      const dots =
        dotsContainer.querySelectorAll(".jt-dot");

      dots.forEach(
        function (dot, index) {

          dot.classList.toggle(
            "active",
            index === currentIndex
          );

        }
      );

    }


    /* ================================
       NEXT
    ================================= */

    function nextSlide() {

      const maxIndex = getMaxIndex();

      if (currentIndex >= maxIndex) {

        currentIndex = 0;

      } else {

        currentIndex++;

      }

      updateSlider();

    }


    /* ================================
       PREVIOUS
    ================================= */

    function previousSlide() {

      const maxIndex = getMaxIndex();

      if (currentIndex <= 0) {

        currentIndex = maxIndex;

      } else {

        currentIndex--;

      }

      updateSlider();

    }


    /* ================================
       BUTTONS
    ================================= */

    next.addEventListener(
      "click",
      function () {

        nextSlide();
        restartAutoplay();

      }
    );


    prev.addEventListener(
      "click",
      function () {

        previousSlide();
        restartAutoplay();

      }
    );


    /* ================================
       AUTOPLAY
    ================================= */

    function startAutoplay() {

      clearInterval(autoplay);

      autoplay = setInterval(
        function () {

          nextSlide();

        },
        4000
      );

    }


    function restartAutoplay() {

      startAutoplay();

    }


    /* ================================
       PAUSE ON HOVER
    ================================= */

    root.addEventListener(
      "mouseenter",
      function () {

        clearInterval(autoplay);

      }
    );


    root.addEventListener(
      "mouseleave",
      function () {

        startAutoplay();

      }
    );


    /* ================================
       RESIZE
    ================================= */

    let resizeTimer;

    window.addEventListener(
      "resize",
      function () {

        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(
          function () {

            const maxIndex = getMaxIndex();

            if (currentIndex > maxIndex) {
              currentIndex = maxIndex;
            }

            createDots();
            updateSlider();

          },
          150
        );

      }
    );


    /* ================================
       INITIALIZE
    ================================= */

    createDots();
    updateSlider();
    startAutoplay();

  }


  /* ================================
     INITIAL LOAD
  ================================= */

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      initTestimonials
    );

  } else {

    initTestimonials();

  }


  /* ECOMPOSER FALLBACK */
  setTimeout(
    initTestimonials,
    500
  );

})();






